import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { ErrorMessage, SuccessMessage, productSuccess, productModelSuccess, productUpdateSuccess, 
    modelTypeCreated} from "src/constants/Constant";
import { AppDispatch, AppThunk } from "src/store";



interface FetchProduct {
    partNumber: string,
    description: string,
    modelType: string,
    markNumber: string,
    image: any,
    prdImageUrl: any,
    id?: number,
    projectNumber: string
}
interface FetchProductById {
    id?: number,
    projectNumber: string,
    partNumber: string,
    description: string,
    modelType: string,
    markNumber: string,
    modelTypeId: string

}
interface ModelTypeDropDown {
    status: string;
    message: string;
    data: {
        count: string;
        rows: [
            {
                modelTypeId: string;
                modelTypeName: string;
                modelTypeImage: string,
                modelTypeImageUrl?: string,
                modelImageType:string,
            }
        ]
    }
}

interface ModelTypeDropDownById {
    status: string;
    message: string;
    data: {
        modelTypeId: string;
        modelTypeName: string;
        modelTypeImage: string,
        modelTypeImageUrl?: string,
        modelImageType:string,
    }
}

interface FetchProductUpload {
    status: boolean,
    message: string
}
interface FetchSpareUploadStatus {
    completed: boolean,
    uploaded: number,
    total: number,
    completedOn: string,
    error: null,
}
interface WhatsNewState {
    addWhatsNewIds: number[];
    removeWhatsNewIds: number[];
}

interface WhatsNewResponse {
    status: string;
    message: string;
}

interface ImageSearchResponse {
    status: string;
    message: string;
    data: {
        count: string;
        result: FetchProduct[];
    };
}

interface AnnouncementItem {
    id: number;
    announcementTitle: string;
    announcementDescription: string;
    announcementImage: string;
    announcementDocs: string;
    createdAt: string;
    updatedAt: string;
    createdById: string;
    announcementDocsUrl: string;
    announcementImageUrl: string;
    isActive: boolean;
}

interface NonBsusNumbersState {
    isLoading: boolean;
    data: {
        count: number;
        result: any[]; 
    } | null;
    error: string | null;
}
interface BulkUpdateState {
    isLoading: boolean;
    data: {
        status: boolean;
        message: string;
    } | null;
    error: string | null;
}



export interface ProductState {
    productData: {
        isloading: boolean,
        status: boolean,
        message: string,
        error: boolean,
        data: {
            count: string,
            result: FetchProduct[]
        };
        
    },
    productDataById: {
        isloading: boolean,
        status: boolean,
        message: string,
        data: FetchProductById
    },
    productDataUpdated: {
        isloading: boolean,
        status: boolean,
        message: string
    },
    productUpload: {
        isloading: boolean,
        data: FetchProductUpload,
        isError: boolean
    },
    productUploadModel: {
        isloading: boolean,
        data: FetchProductUpload,
        isError: boolean
    },
    productUploadMark: {
        isloading: boolean,
        data: FetchProductUpload,
        isError: boolean
    },
    pagination: {
        max: string | number,
        limit: any,
        currentPage: any,
        data: {
            count: string,
            result: Array<FetchProduct>
        }

    },
    modelTypeData: {
        isloading: boolean,
        data: ModelTypeDropDown;
    },
    modelTypeDataById: {
        isloading: boolean,
        data: ModelTypeDropDownById;
    }
    AlertMessageState: {
        show: boolean;
        type: string;
        message: string;
        showModal: boolean;
    },
    StatusMessageState: {
        loading: boolean;
        show: boolean;
        message: string;
        status: boolean;
        data: {
            completed: boolean
        }
    },
    SpareSheetStatusState: {
        loading: boolean;
        show: boolean;
        message: string;
        status: boolean;
        data: {
            completed: boolean
        }
    },
    prodUploadStatus: {
        isloading: boolean,
        status: boolean,
        message: string,
        data: FetchSpareUploadStatus[]
    },
    bulkUpdate: {
        isLoading: boolean;
        data: WhatsNewResponse | null;
        error: string | null;
    },
    AnnouncementItem: {
        id: number;
        announcementTitle: string;
        announcementDescription: string;
        announcementImage: string;
        announcementDocs: string;
        createdAt: string;
        updatedAt: string;
        createdById: string;
        announcementDocsUrl: string;
        announcementImageUrl: string;
        isActive: boolean;
    }
    AnnouncementState: {
        loading: boolean;
        error: string | null;
        success: boolean;
        list: AnnouncementItem[]
    },
    productUpdateStatus: {
        isloading: boolean;
        status: boolean;
        message: string;
        error: boolean;
    },
    productStateDelete: {
        items: any[],
        loading: boolean,
        error: string | null,
    },

    selectedProductIds: number[];
    unselectedProductIds: number[];
    whatsNewProducts: any[];
    whatsNewCount: number;

    //product catolog
    projectOptions: Array<{ value: string; label: string }>;
    serialOptions: Array<{ value: string; label: string }>;
    spareParts: any[];
    nonBsusNumbers: NonBsusNumbersState;
    updateProductNumbers: BulkUpdateState;
    imageSearch: {
        isloading: boolean;
        data: ImageSearchResponse | null;
        error: string | null;
    };
    deletedProducts: {
        isloading: boolean;
        data: {
            count: string;
            result: FetchProduct[];
        } | null;
        error: string | null;
    };
    updateSpecificSparePart: {
        isloading: boolean;
        data: any;
        error: boolean;
    };
    // productData:ProductDataState;

}
const initialState: ProductState = {
    productData: {
        isloading: true,
        status: false,
        error: false,
        message: '',
        data: {
            count: '',
            result: []
        }
    },
    productDataById: {
        isloading: false,
        status: false,
        message: '',
        data: null
    },
    productDataUpdated: {
        isloading: false,
        status: false,
        message: '',
    },
    productUpload: {
        isloading: false,
        data: null,
        isError: false
    },
    productUploadModel: {
        isloading: false,
        data: null,
        isError: false
    },
    productUploadMark: {
        isloading: false,
        data: null,
        isError: false
    },
    pagination: {
        max: 1,
        limit: 10,
        currentPage: 0,
        data: {
            count: '',
            result: [],
        }
    },
    modelTypeData: {
        isloading: false,
        data: null
    },
    modelTypeDataById: {
        isloading: false,
        data: null
    },
    AlertMessageState: {
        show: false,
        type: '',
        message: '',
        showModal: false
    },
    StatusMessageState: {
        loading: false,
        show: false,
        message: '',
        status: false,
        data: null
    },
    SpareSheetStatusState: {
        loading: false,
        show: false,
        message: '',
        status: false,
        data: null
    },
    prodUploadStatus: {
        isloading: false,
        status: true,
        message: '',
        data: []
    },
    bulkUpdate: {
        isLoading: false,
        data: null,
        error: null,
    },
    selectedProductIds: [],
    unselectedProductIds: [],
    whatsNewProducts: [],
    whatsNewCount: 0,
    projectOptions: [],
    serialOptions: [],
    spareParts: [],
    AnnouncementState: {
        loading: false,
        error: null,
        success: false,
        list: [],
    },
    AnnouncementItem: {
        id: 0,
        announcementTitle: "",
        announcementDescription: "",
        announcementImage: "",
        announcementDocs: "",
        createdAt: "",
        updatedAt: "",
        createdById: "",
        announcementDocsUrl: "",
        announcementImageUrl: "",
        isActive: false,
    },
    productUpdateStatus: {
        isloading: false,
        status: false,
        message: "",
        error: false
    },
    productStateDelete: {
        items: [],
        loading: false,
        error: null,
    },
     nonBsusNumbers: {
        isLoading: false,
        data: null,
        error: null,
    },
    updateProductNumbers: {
        isLoading: false,
        data: null,
        error: null,
    },
    imageSearch: {
        isloading: false,
        data: null,
        error: null,
    },
    deletedProducts: {
        isloading: false,
        data: null,
        error: null,
    },
    updateSpecificSparePart: {
        isloading: false,
        data: null,
        error: false,
    },
}

const Slice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        productIsLoading(state) {
            state.productData.isloading = true;
        },
        productReceived: (state, action) => {
            state.productData = action.payload;
            state.productData = {
                ...state.productData,
                isloading: false,
                error: false
            }
        },
        productReceivedByIdLoading: (state) => {
            state.productDataById.isloading = true;
        },
        productReceivedById: (state, action) => {
            state.productDataById = action.payload;
            state.productDataById = {
                ...state.productDataById,
                isloading: false
            }
        },
        productDataUpdatedLoading: (state) => {
            state.productDataUpdated.isloading = true;
        },
        productDataUpdatedById: (state, action) => {
            state.productDataUpdated = action.payload;
            state.productDataUpdated.isloading = false;
            state.productDataById = {
                ...state.productDataById,
                isloading: false
            }
        },
        productUplIsLoading(state) {
            state.productUpload.isloading = true;
        },
        uploadModelTypeLoading(state) {
            state.modelTypeData.isloading = true;
        },
        uploadModelTypeSuccess(state, action) {
            state.modelTypeData.isloading = false;
            state.modelTypeData.data = action.payload;
            state.AlertMessageState = {
                show: true,
                type: SuccessMessage,
                message: modelTypeCreated,
                showModal: false,
            };
        },
        uploadModelTypeFailure(state, action) {
            state.modelTypeData.isloading = false;
            state.AlertMessageState = {
                show: true,
                type: ErrorMessage,
                message: action.payload,
                showModal: false,
            };
        },
        productUplIsModelLoading(state) {
            state.productUploadModel.isloading = true;
        },
        productUplIsMarkLoading(state) {
            state.productUploadMark.isloading = true;
        },
        GetproductError(state, action) {
            state.productData = {
                ...state.productData,
                isloading: false,
                error: true,
                data: action.payload
            };
        },
        GetproductByIdError(state, action) {
            state.productDataById = {
                ...state.productDataById,
                isloading: false,
                data: action.payload
            };
        },
        GetproductUplError(state, action) {
            state.productUpload = {
                ...state.productUpload,
                isloading: false,
                data: action.payload
            };
        },
        GetproductUplModelError(state, action) {
            state.productUploadModel = {
                ...state.productUploadModel,
                isloading: false,
                data: action.payload
            };
        },
        GetproductUplMarkError(state, action) {
            state.productUploadMark = {
                ...state.productUploadMark,
                isloading: false,
                data: action.payload
            };
        },

        productUploaded: (state, action) => {
            state.productUpload = {
                ...state.productUpload,
                isloading: false,
                isError: false,
                data: action.payload
            };

        },
        productUploadedModel: (state, action) => {
            state.productUploadModel = {
                ...state.productUploadModel,
                isloading: false,
                isError: false,
                data: action.payload
            };

        },
        productUploadedMark: (state, action) => {
            state.productUploadMark = {
                ...state.productUploadMark,
                isloading: false,
                isError: false,
                data: action.payload
            };

        },

        paginationItem(state, action) {
            state.pagination = action.payload;
            state.pagination.limit = 10
        },
        modelItemReduLoading(state) {
            state.modelTypeData.isloading = true;
        },
        modelItemRedu(state, action) {
            state.modelTypeData = {
                ...state.modelTypeData,
                isloading: false,
                data: action.payload
            }
        },
        modelItemReduByIdLoading(state) {
            state.modelTypeDataById.isloading = true;
        },
        modelItemReduById(state, action) {
            state.modelTypeDataById = {
                ...state.modelTypeDataById,
                isloading: false,
                data: action.payload
            }
        },
        modelItemErrorReduId(state, action) {
            state.modelTypeDataById = {
                ...state.modelTypeDataById,
                isloading: false,
                data: action.payload
            };
        },
        modelItemErrorRedu(state, action) {
            state.modelTypeData = {
                ...state.modelTypeData,
                isloading: false,
                data: action.payload
            };
        },
        clearData(state) {
            state.productUpload.data.status = false
        },
        clearModelImgData(state) {
            state.modelTypeDataById.data.data.modelTypeImageUrl = ''
            state.modelTypeDataById.data.data.modelTypeImage = ''
            state.modelTypeDataById.data.data.modelImageType=''

        },
        clearModelData(state) {
            state.productUploadModel.data.status = false
        },
        clearMarkData(state) {
            state.productUploadMark.data.status = false
        },
        clearProductData(state) {
            state.productData.isloading = true;
        },
        spareStatusUploadLoading(state) {
            state.prodUploadStatus.isloading = true;
        },
        showStatusMessageLoading(state) {
            state.StatusMessageState.loading = true
        },
        showStatusMessage(state, action) {
            state.StatusMessageState = {
                ...state.StatusMessageState,
                loading: false,
                show: true,
                status: true,
                message: action.payload.message,
                data: action.payload.data
            };
        },
        showStatusMessageError(state, action) {
            state.StatusMessageState = {
                ...state.StatusMessageState,
                loading: false,
                status: false,
                message: action.payload.message
            };
        },
        showAlertMessage(state, action) {
            state.AlertMessageState = {
                show: true,
                type: action.payload.type,
                message: action.payload.message,
                showModal: action.payload.showModal,
            };
        },
        showSpareSheetStatusLoading(state) {
            state.SpareSheetStatusState.loading = true
        },
        showSpareSheetStatus(state, action) {
            state.SpareSheetStatusState = {
                ...state.SpareSheetStatusState,
                loading: false,
                show: true,
                status: true,
                message: action.payload.message,
                data: action.payload.data
            };
        },
        showSpareSheetStatusError(state, action) {
            state.SpareSheetStatusState = {
                ...state.SpareSheetStatusState,
                loading: false,
                status: false,
                message: action.payload.message
            };
        },
        clearSpareSheetStatusData(state) {
            state.SpareSheetStatusState = {
                loading: false,
                message: 'Message cleared',
                data: null,
                status: false,
                show: false
            };
        },
        clearStatusMessageData(state) {
            state.StatusMessageState = {
                loading: false,
                message: 'Message cleared',
                data: null,
                status: false,
                show: false
            };
        },
        clearmodelItemReduById(state) {
            state.modelTypeDataById = {
                ...state.modelTypeDataById,
                isloading: false,
                data: null
            }
        },
        clearAlertMessage(state) {
            state.AlertMessageState = {
                show: false,
                type: null,
                message: null,
                showModal: false,
            };
        },
        bulkUpdateLoading(state) {
            state.bulkUpdate.isLoading = true;
            state.bulkUpdate.error = null;
        },
        bulkUpdateSuccess(state, action: PayloadAction<WhatsNewResponse>) {
            state.bulkUpdate.isLoading = false;
            state.bulkUpdate.data = action.payload;
        },
        bulkUpdateFailure(state, action: PayloadAction<any>) {
            state.bulkUpdate.isLoading = false;
            state.bulkUpdate.error = action.payload;
        },
        setSelectedProductIds: (state, action:
            PayloadAction<number[]>) => {
            state.selectedProductIds = action.payload;
        },
        setUnselectedProductIds: (state, action: PayloadAction<number[]>) => { 
            state.unselectedProductIds = action.payload;
        },

        clearSelectedProductIds: (state) => {
            state.selectedProductIds = [];
        },
        clearUnselectedProductIds: (state) => { 
            state.unselectedProductIds = [];
        },
        setWhatsNewProducts: (state, action: PayloadAction<any[]>) => {
            state.whatsNewProducts = action.payload;
        },
        setWhatsNewCount(state, action: PayloadAction<number>) {
            state.whatsNewCount = action.payload;
        },
        //catolog
        setProjectOptions(state, action) {
            state.projectOptions = action.payload;
        },
        setSerialOptions(state, action) {
            state.serialOptions = action.payload;
        },
        setSpareParts(state, action) {
            state.spareParts = action.payload;
        },
        //Announcements
        setLoading: (state) => {
            state.AnnouncementState.loading = true;
            state.AnnouncementState.error = null;
            state.AnnouncementState.success = false;
        },
        setSuccess: (state) => {
            state.AnnouncementState.loading = false;
            state.AnnouncementState.success = true;
        },
        setError: (state, action) => {
            state.AnnouncementState.loading = false;
            state.AnnouncementState.error = action.payload;
            state.AnnouncementState.success = false;
        },
        resetAnnouncementState: (state) => {
            state.AnnouncementState.loading = false;
            state.AnnouncementState.error = null;
            state.AnnouncementState.success = false;
        },
        setAnnouncements: (state, action) => {
            state.AnnouncementState.list = action.payload;
        },
        AddAnnouncementLocal: (state, action) => {
            state.AnnouncementState.list.unshift(action.payload)
        },
        updateAnnouncementLocal: (state, action) => {
            const updated = action.payload;
            const idx = state.AnnouncementState.list.findIndex((ann) => ann.id === updated.id);
            if (idx !== -1) {
                state.AnnouncementState.list[idx] = updated;
            }
        },
        deleteAnnouncement: (state, action) => {
            state.AnnouncementState.list = state.AnnouncementState.list.filter((ann) => ann.id !== action.payload);
            state.AnnouncementState.loading = false;
        },
        updateProductLoading(state) {
            state.productUpdateStatus.isloading = true;
            state.productUpdateStatus.status = false;
            state.productUpdateStatus.message = '';
            state.productUpdateStatus.error = false;
        },
        updateProductSuccess(state, action) {
            state.productUpdateStatus.isloading = false;
            state.productUpdateStatus.status = true;
            state.productUpdateStatus.message = action.payload?.message || 'Update Successfull';
        },
        updateProductFailure(state, action) {
            state.productUpdateStatus.isloading = false;
            state.productUpdateStatus.status = false;
            state.productUpdateStatus.message = action.payload;
            state.productUpdateStatus.error = true
        },

        setLoader: (state, action) => {
            state.productStateDelete.loading = action.payload;
        },
        setErrors: (state, action) => {
            state.productStateDelete.error = action.payload;
        },
        removeProduct: (state, action) => {
            state.productStateDelete.items = state.productStateDelete.items.filter(
                (product) => product.id !== action.payload
            );
        },
        //new product numbers
        fetchNonBsusNumbersLoading(state) {
        state.nonBsusNumbers.isLoading = true;
        state.nonBsusNumbers.error = null;
    },
    fetchNonBsusNumbersSuccess(state, action) {
        state.nonBsusNumbers.isLoading = false;
         state.nonBsusNumbers.data = action.payload.data || action.payload;
        state.nonBsusNumbers.error = null;
    },
    fetchNonBsusNumbersError(state, action) {
        state.nonBsusNumbers.isLoading = false;
        state.nonBsusNumbers.error = action.payload;
    },
    updateProductNumbersLoading(state) {
            state.bulkUpdate.isLoading = true;
            state.bulkUpdate.error = null;
        },
        updateProductNumbersSuccess(state, action) {
            state.bulkUpdate.isLoading = false;
            state.bulkUpdate.data = action.payload;
            state.bulkUpdate.error = null;
        },
        updateProductNumbersFailure(state, action) {
            state.bulkUpdate.isLoading = false;
            state.bulkUpdate.error = action.payload;
            state.bulkUpdate.data = null;
        },
        imageSearchLoading(state) {
            state.imageSearch.isloading = true;
            state.imageSearch.error = null;
        },
        imageSearchSuccess(state, action) {
            state.imageSearch.isloading = false;
            state.imageSearch.data = action.payload;
            state.imageSearch.error = null;
        },
        imageSearchFailure(state, action) {
            state.imageSearch.isloading = false;
            state.imageSearch.error = action.payload;
            state.imageSearch.data = null;
        },
        deletedProductsLoading(state) {
            state.deletedProducts.isloading = true;
            state.deletedProducts.error = null;
        },
        deletedProductsSuccess(state, action) {
            state.deletedProducts.isloading = false;
            state.deletedProducts.data = action.payload.data;
            state.deletedProducts.error = null;
        },
        deletedProductsFailure(state, action) {
            state.deletedProducts.isloading = false;
            state.deletedProducts.error = action.payload;
            state.deletedProducts.data = null;
        },
        updateSpecificSparePartLoading(state) {
            state.updateSpecificSparePart.isloading = true;
        },
        updateSpecificSparePartSuccess(state, action) {
            state.updateSpecificSparePart.isloading = false;
            state.updateSpecificSparePart.data = action.payload;
        },
        updateSpecificSparePartError(state, action) {
            state.updateSpecificSparePart.isloading = false;
            state.updateSpecificSparePart.error = true;
        },
    },
});
// Fetch Limit products
export const FetchProdData = (data: any) => async (dispatch: any) => {
    dispatch(Slice.actions.productIsLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/products?page=${data}`)
        dispatch(Slice.actions.productReceived(res.data));
    } catch (err) {
        dispatch(Slice.actions.GetproductError(err));
    }
}

// Update Product
export const FetchProdDataById = (dataq: any) => async (dispatch: any) => {
    dispatch(Slice.actions.productReceivedByIdLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/products/${dataq}`)
        dispatch(Slice.actions.productReceivedById(res.data));
    } catch (err) {
        dispatch(Slice.actions.GetproductByIdError(err));
    }
}

export const UpdateProdDataById = (id: any, data: any) => async (dispatch: any) => {
    dispatch(Slice.actions.productDataUpdatedLoading());
    try {
        const res = await axios.put(`${process.env.REACT_APP_BASE_URL}/products/${id}?`, data);
        dispatch(Slice.actions.productDataUpdatedById(res.data));
        dispatch(Slice.actions.showAlertMessage({
            message: productUpdateSuccess,
            type: SuccessMessage
        }));

    } catch (err) {
        dispatch(Slice.actions.GetproductByIdError(err));
        dispatch(Slice.actions.showAlertMessage({
            message: err.message,
            type: ErrorMessage
        }));
    }
}

// Fetch All products for pagination
export const FetchAllProd = () => async (dispatch: any) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/products?size=all`)
        dispatch(Slice.actions.paginationItem(res.data));

    } catch (err) {
        dispatch(Slice.actions.GetproductError(err));
    }
}
// get ModelType Dropdown
export const dropDownModelType = () => async (dispatch: any) => {
    dispatch(Slice.actions.modelItemReduLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/modeltype?size=all`)
        dispatch(Slice.actions.modelItemRedu(res.data));

    } catch (err) {
        dispatch(Slice.actions.modelItemErrorRedu(err));
    }
}

// get ModelType By ID
export const getModelTypeById = (data: any) => async (dispatch: any) => {
    dispatch(Slice.actions.modelItemReduByIdLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/modeltype/${data}`)
        dispatch(Slice.actions.modelItemReduById(res.data));

    } catch (err) {
        dispatch(Slice.actions.modelItemErrorReduId(err));
    }
}


// Update ModelType By ID
export const updateModelTypeById = (data: FormData, currentIs3DModel: any) => async (dispatch: any) => {
    console.log("FormData contents:");
    for (let pair of data.entries()) {
        console.log(pair[0] + ': ', pair[1]);
    }
    dispatch(Slice.actions.modelItemReduByIdLoading()); 
    try {
        console.log("Sending request to server...");
        const res = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/updatemodeltype`,
            data
        );
        console.log("Server response:", res.data); 
        dispatch(Slice.actions.modelItemReduById(res.data));
        dispatch(Slice.actions.showAlertMessage({
            message: "ModelType updated successfully.",
            type: "success"
        }));
    } catch (err) {
        console.error("Error updating model type:", err); 
        dispatch(Slice.actions.modelItemErrorReduId(err));
        dispatch(Slice.actions.showAlertMessage({
            message: err.response?.data?.message || err.message,
            type: "error"
        }));
    }
};


// Create ModelType
export const createModelType = (data: any) => async (dispatch: any) => {
    dispatch(Slice.actions.modelItemReduByIdLoading());
    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/modeltype`, data)
        dispatch(Slice.actions.modelItemReduById(res.data));
        dispatch(Slice.actions.showAlertMessage({
            message: modelTypeCreated,
            type: SuccessMessage
        }));

    } catch (err) {
        dispatch(Slice.actions.modelItemErrorReduId(err));
        dispatch(Slice.actions.showAlertMessage({
            message: err.message,
            type: ErrorMessage
        }));
    }
}

// Search Results
export const SearchProduct = (partNumber: any, projectNumber: any, markNumber: any, page: any) => async (dispatch: any) => {
    dispatch(Slice.actions.productIsLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/products?partNumber=${partNumber.trim()}&projectNumber=${projectNumber.trim()}&markNumber=${markNumber.trim()}&page=${page}`)
        dispatch(Slice.actions.productReceived(res.data))

    } catch (err) {
        dispatch(Slice.actions.GetproductError(err));
    }
}

// Upload Excel Data
export const uploadExcelDataProd = (DatQ: any) => async (dispatch: any) => {
    dispatch(Slice.actions.productUplIsLoading());
    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/products/upload`, DatQ);
        dispatch(Slice.actions.productUploaded(res.data))
        dispatch(Slice.actions.showAlertMessage({
            message: productSuccess,
            type: SuccessMessage
        }));
        dispatch(FetchProdData(0))
    } catch (error) {
        dispatch(Slice.actions.GetproductUplError(error));
        dispatch(Slice.actions.showAlertMessage({
            message: error.message,
            type: ErrorMessage
        }));
    }
}

// Upload Excel Data
export const uploadExcelModelData = (DatQ: any) => async (dispatch: any) => {
    dispatch(Slice.actions.productUplIsModelLoading());
    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/products/uploadproductsinfo/modelType`, DatQ);
        dispatch(Slice.actions.productUploadedModel(res.data))
        dispatch(Slice.actions.showAlertMessage({
            message: productModelSuccess,
            type: SuccessMessage
        }));
    } catch (error) {
        dispatch(Slice.actions.GetproductUplModelError(error));
        dispatch(Slice.actions.showAlertMessage({
            message: error.message,
            type: ErrorMessage
        }));
    }
}

// Upload Excel Data
export const uploadExcelMarkData = (DatQ: any) => async (dispatch: any) => {
    dispatch(Slice.actions.productUplIsMarkLoading());
    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/products/uploadproductsinfo/markNumber`, DatQ);
        dispatch(Slice.actions.productUploadedMark(res.data));
        dispatch(Slice.actions.showAlertMessage({
            message: productModelSuccess,
            type: SuccessMessage
        }));
    } catch (error) {
        dispatch(Slice.actions.GetproductUplMarkError(error));
        dispatch(Slice.actions.showAlertMessage({
            message: error.message,
            type: ErrorMessage
        }));
    }
}

// Upload New D365
export const uploadNewD365 = (DatQ: any) => async (dispatch: any) => {
   
    dispatch(Slice.actions.showStatusMessageLoading());

    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/spareParts/products-spareparts-combine-upload`, DatQ);
        dispatch(Slice.actions.showStatusMessage(res.data));
       
    } catch (error) {
        dispatch(Slice.actions.showStatusMessageError(error));
       
    }
}

// Upload Spare Sheet
export const uploadSpareSheet = (DatQ: any) => async (dispatch: any) => {
    dispatch(Slice.actions.showSpareSheetStatusLoading());

    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/updatespareparts`, DatQ);
        dispatch(Slice.actions.showSpareSheetStatus(res.data));
    } catch (error) {
        dispatch(Slice.actions.showSpareSheetStatusError(error));
    }
}

// Status of Spare Sheet Upload
export const statusSpareSheet = () => async (dispatch: any) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/spareParts/getfileuploadstatus/UPDATE_SPAREPARTS-Data-sheet`);
        dispatch(Slice.actions.showSpareSheetStatus(res.data));
    } catch (error) {
        if (error.response?.status === 400 || error.response?.status === 404) {
            dispatch(Slice.actions.showSpareSheetStatusError({
                message: "Upload session not found. Please try uploading again.",
                status: false
            }));
            return;
        }
        dispatch(Slice.actions.showSpareSheetStatusError(error));
    }
}

export const clearSpareSheetStatus = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearSpareSheetStatusData());
};

// Status of New D365
export const statusNewD365 = () => async (dispatch: any) => {
    dispatch(Slice.actions.spareStatusUploadLoading());
    
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/spareParts/getfileuploadstatus/BOM_D365_Product-Details`);
       
        dispatch(Slice.actions.showStatusMessage(res.data));
        
    } catch (error) {
        dispatch(Slice.actions.showStatusMessageError(error));
        dispatch(Slice.actions.showAlertMessage({
            message: error.message,
            type: ErrorMessage
        }));
    }
}
//whats new
export const bulkUpdateProducts = (data: WhatsNewState) =>
    async (dispatch: any) => {
        dispatch(Slice.actions.bulkUpdateLoading());

        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/modeltype/bulkUpdate`,
                data
            );

            dispatch(Slice.actions.bulkUpdateSuccess(response.data));

            dispatch(
                Slice.actions.showAlertMessage({
                    message: 'Successfully Updated',
                    type: 'success',
                })
            );

            return response.data;
        } catch (err) {
            dispatch(Slice.actions.bulkUpdateFailure(err));
            dispatch(Slice.actions.showAlertMessage({
                message: err.message,
                type: ErrorMessage
            }));
        }

    };

//fetching whats new products
export const fetchWhatsNewProducts = () => async (dispatch: any) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/modeltype?size=all`);
        const { rows} = response.data.data;
        dispatch(Slice.actions.setWhatsNewProducts(rows));

    } catch (error) {
        dispatch(Slice.actions.showStatusMessageError(error));
        dispatch(Slice.actions.showAlertMessage({
            message: error.message,
            type: ErrorMessage
        }));
    }
};
export const fetchProjects = (): AppThunk => async (dispatch) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/projects/list`);
        const data = res.data.data.map((id: string) => ({
            value: id,
            label: id,
        }));
        dispatch(Slice.actions.setProjectOptions(data));
    } catch (err) {
        console.error("Fetch projects failed", err);
    }
};

export const fetchSerials = (projectId: string): AppThunk => async (dispatch) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/projects/${projectId}/products`);
        const data = res.data.data.map((serial: string) => ({
            value: serial.split('-').pop(),
            label: serial.split('-').pop(),
        }));
        dispatch(Slice.actions.setSerialOptions(data));
    } catch (err) {
        console.error("Fetch serials failed", err);
    }
};

export const fetchSpareParts = (payload: { projectId: string; serialId: string }): AppThunk => async (dispatch) => {
    try {
        const formattedProjectId = payload.projectId.split(" ")[0];
        console.log(formattedProjectId);
        const requestUrl = `${process.env.REACT_APP_BASE_URL}/products/partnumbers/${formattedProjectId}-${payload.serialId}?size=all`;

        console.log("Requesting Spare Parts for:", requestUrl);

        const res = await axios.get(requestUrl);

        if (!res.data?.data?.spareParts) {
            throw new Error("No spare parts found.");
        }

        dispatch(Slice.actions.setSpareParts(res.data.data.spareParts));
    } catch (err) {
        console.error("Fetch spare parts failed:", err.response?.data || err.message);
        dispatch(Slice.actions.setSpareParts([]));
    }
};
//Announcement
export const submitAnnouncement = (
    payload: { title: string; description: string; imageFile: File | null; pdfFile: File | null, isActive: any }
) => async (dispatch: AppDispatch) => {
    try {
        dispatch(setLoading());

        const formData = new FormData();
        formData.append('title', payload.title);
        formData.append('description', payload.description);
        formData.append('isActive', String(Boolean(payload.isActive)));
        if (payload.imageFile) formData.append('image', payload.imageFile);
        if (payload.pdfFile) formData.append('documents', payload.pdfFile);


        await axios.post(
            `${process.env.REACT_APP_BASE_URL}/announcement`,
            formData
        );

        dispatch(setSuccess());
    } catch (error: any) {
        dispatch(setError(error?.response?.data?.message || 'Something went wrong'));
    }
};

export const fetchAnnouncements = () => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/announcement?page=0&size=100`);
        dispatch(setAnnouncements(response.data.data.rows));
        console.log("data", response.data.data.rows)
    } catch (error) {
        console.error('Error fetching announcements:', error);
    }
};

export const updateAnnouncement = createAsyncThunk(
    'announcements/updateAnnouncement',
    async (formData: FormData, thunkAPI) => {
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/updateAnnouncement`,
                formData
            );
            return response.data.data;
        } catch (error: any) {
            console.log('Redux thunk caught error:', error);
            const errorData = error?.data || error?.response?.data || error;
            return thunkAPI.rejectWithValue(errorData);
        }
    }
);

export const deleteAnnouncementPage = (announcementId: number) => async (dispatch: AppDispatch) => {
    try {
        dispatch(setLoading());
        await axios.delete(`${process.env.REACT_APP_BASE_URL}/announcement/${announcementId}`);
        dispatch(deleteAnnouncement(announcementId));
    } catch (err: any) {
        console.error('Delete announcement failed:', err);
        dispatch(setError('Delete Failed'));
    }
};

export const fetchProductsByProjectId = (projectNumber: string) => async (dispatch: any) => {
    dispatch(Slice.actions.productIsLoading());

    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/products?projectNumber=${projectNumber}&size=all`);

        dispatch(
            Slice.actions.productReceived(response.data));
        console.log("data", response.data)
    } catch (err: any) {
        console.error('Fetch products by project ID failed:', err);
        dispatch(
            Slice.actions.productReceived({
                isloading: false,
                status: false,
                message: err.message || 'Something went wrong',
                error: true,
                data: {
                    count: '0',
                    result: [],
                },
            })
        );
    }
};
//new product update
export const updateProductId = createAsyncThunk(
    'product/updateProductId',
    async ({ isSelectAll, payload }: { isSelectAll: boolean; payload: any }, thunkAPI) => {
        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/products/update-product-id?isSelectAll=${isSelectAll}`,
                payload
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

//Acknowledgement

export const uploadAckPdf = createAsyncThunk(
    "product/uploadAckPdf",
    async (formData: FormData, thunkAPI) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/products/ackpdf`,
                formData
            );
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || "Upload failed"
            );
        }
    }
);
//modify ack
export const modifyAckPdf = async (formData: FormData, retryCount = 0): Promise<Blob> => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/products/ackpdfpricetag`,
            formData,
            {
                responseType: 'blob',
            }
        );
        return response.data;
    }
    catch (error) {
        console.error('Modify Ack PDF failed:', error);
        throw error;
    }
};
//Delete Product 
export const deleteProduct = (id: number) => async (dispatch: any) => {
    try {
        dispatch(Slice.actions.setLoader(true));
        await axios.delete(
            `${process.env.REACT_APP_BASE_URL}/products/${id}`
        );
        dispatch(Slice.actions.removeProduct(id.toString()));
    } catch (error: any) {
        dispatch(Slice.actions.setErrors(error.response?.data || "Error deleting product"));
    } finally {
        dispatch(Slice.actions.setLoader(false));
    }
};

export const fetchNonBsusNumbers = () => async (dispatch: any) => {
  dispatch(Slice.actions.fetchNonBsusNumbersLoading());
  try {
    const url = `${process.env.REACT_APP_BASE_URL}/getnonbsusnumbers?size=all`;
    console.log("Request URL:", url);
    const res = await axios.get(url);
    dispatch(Slice.actions.fetchNonBsusNumbersSuccess(res.data));
    console.log("Response Data:", res.data);
  } catch (err) {
    console.error("API Error:", err);
    dispatch(Slice.actions.fetchNonBsusNumbersError(err.message));
  }
};


export const bulkUpdatePartNumbers = (
    payload: {
        addPartNo: Array<{ id: number; updatedPartNumber: string; oldPartNumber: string }>;
       
    }
) => async (dispatch: any) => {
    if (!payload.addPartNo || payload.addPartNo.length === 0) {
        dispatch(updateProductNumbersFailure("No records selected. Please check at least one item to update"));
        dispatch(Slice.actions.showAlertMessage({
            message: "No records selected. Please check at least one item to update",
            type: "error",
        }));
        return;
    }

    dispatch(updateProductNumbersLoading());
    try {
        const res = await axios.patch(
            `${process.env.REACT_APP_BASE_URL}/spareparts/bulkUpdate`,
            payload
        );
        dispatch(updateProductNumbersSuccess(res.data));
        dispatch(Slice.actions.showAlertMessage({
            message: "Part numbers updated successfully",
            type: "success",
        }));
        dispatch(fetchNonBsusNumbers());
    } catch (err) {
        dispatch(updateProductNumbersFailure(err.response?.data?.message || "Update failed"));
        dispatch(Slice.actions.showAlertMessage({
            message: "No records selected. Please check at least one item to update",
            type: "error",
        }));
    }
};

// Initialize Image Hashes API
export const initializeImageHashes = () => async (dispatch: any) => {
    try {
        await axios.post(`${process.env.REACT_APP_BASE_URL}/products/initialize-image-hashes`);
    } catch (err) {
        console.error('Error initializing image hashes:', err);
    }
};

// Image Search API
export const fetchDeletedProducts = () => async (dispatch: any) => {
    dispatch(Slice.actions.deletedProductsLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/getdeletedproducts?size=all`);
        dispatch(Slice.actions.deletedProductsSuccess(res.data));
    } catch (err) {
        dispatch(Slice.actions.deletedProductsFailure(err.response?.data?.message || 'Failed to fetch deleted products'));
    }
};

export const restoreProducts = (productIds: number[]) => async (dispatch: any) => {
    try {
        const res = await axios.patch(`${process.env.REACT_APP_BASE_URL}/restoreproducts`, {
            restoreProductsIds: productIds
        });
        return res.data;
    } catch (err) {
        throw err.response?.data?.message || 'Failed to restore products';
    }
};

export const searchByImage = (imageFile: File, newPageIndex: number) => async (dispatch: any) => {
   
    dispatch(Slice.actions.imageSearchLoading());
    try {
        const formData = new FormData();
        formData.append('file', imageFile);
        
        const res = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/products/search-by-image`,
            formData
        );
        
       
        dispatch(Slice.actions.imageSearchSuccess(res.data));
        
        const productsData = res.data.data?.products;
        
        if (productsData?.result?.length > 0) {
            dispatch(Slice.actions.productReceived({
                isloading: false,
                status: res.data.status,
                message: res.data.message,
                error: false,
                data: {
                    count: productsData.count || productsData.result.length,
                    result: productsData.result
                }
            }));
        } else {
            dispatch(Slice.actions.productReceived({
                isloading: false,
                status: false,
                message: "No products found",
                error: false,
                data: { count: 0, result: [] }
            }));
        }
    } catch (err) {
       
        const errorMessage = err.response?.data?.message || 'Image search failed';
        dispatch(Slice.actions.imageSearchFailure(errorMessage));
        dispatch(Slice.actions.productReceived({
            isloading: false, status: false, message: errorMessage, error: false,
            data: { count: 0, result: [] }
        }));
       
    }
};

export const searchAllBSUS = (data: any, page: any) => async (dispatch: any) => {
    dispatch(Slice.actions.fetchNonBsusNumbersLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/spareparts?searchText=${data.trim()}&page=0`)
        dispatch(Slice.actions.fetchNonBsusNumbersSuccess(res.data.data))

    } catch (err) {
        dispatch(Slice.actions.fetchNonBsusNumbersError(err));
    }
}

export const updateSpecificSparePart = (data: any) => async (dispatch: any) => {
    dispatch(Slice.actions.updateSpecificSparePartLoading());
    try {
        const res = await axios.patch(
            `${process.env.REACT_APP_BASE_URL}/updatespecificspareparts`,
            data
        );
        dispatch(Slice.actions.updateSpecificSparePartSuccess(res.data));
        return res.data;
    } catch (err) {
        dispatch(Slice.actions.updateSpecificSparePartError(err));
        throw err;
    }
};



export const clearAlertMessage = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearAlertMessage());
};

export const clearDataInfo = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearData())
}
export const clearDataModelImgInfo = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearModelImgData())
}
export const clearDataModelItemInfo = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearmodelItemReduById())
}
export const clearStatusMessage = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearStatusMessageData());
};
export const clearSpareSheetStatusMessage = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearSpareSheetStatusData());
};
export const clearProductDataLoading = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearProductData());
};
export const updateSelectedProductIds = (ids: number[]) => async (dispatch: any) => {
    dispatch(Slice.actions.setSelectedProductIds(ids));
};
export const updateUnselectedProductIds = (ids: number[]) => async (dispatch: any) => {
    dispatch(Slice.actions.setUnselectedProductIds(ids));
};
export const { modelItemRedu } = Slice.actions;
export const { setSelectedProductIds, clearSelectedProductIds, setUnselectedProductIds,
    clearUnselectedProductIds, setWhatsNewProducts, setWhatsNewCount, setLoading, setSuccess,
    setError, resetAnnouncementState, setAnnouncements, updateAnnouncementLocal,
    deleteAnnouncement, setLoader, setErrors, removeProduct,fetchNonBsusNumbersLoading,
    fetchNonBsusNumbersSuccess,imageSearchSuccess,imageSearchFailure, imageSearchLoading,
    fetchNonBsusNumbersError,updateProductNumbersLoading, updateProductNumbersSuccess,
    updateProductNumbersFailure} = Slice.actions;

export const reducer = Slice.reducer;
export default Slice;